import { Calendar, dayjsLocalizer, Views } from "react-big-calendar";
import dayjs from "dayjs";
import "react-big-calendar/lib/css/react-big-calendar.css";
import AppointmentEvent from "./Events/AppointmentEvent";
import BlockoutEvent from "./Events/BlockoutEvent";
import CalendarHeader from "./CalendarHeader";
import { useCallback, useMemo, useState } from "react";
import { cloneElement } from "react";
import { useContext } from "react";
import { ScheduleForm } from "./Form/ScheduleForm";
import EventPopup from "./Events/EventPopup";
import { popupcontext } from "../../../../context/Popupscontext";
import Upcoming from "./Upcoming";
import ViewMore from "./ViewMore/ViewMore";
import { events } from "../../../../constants";

const localizer = dayjsLocalizer(dayjs);

const Schedule = () => {
  const [customView, setCustomView] = useState(Views.DAY);
  const [contextMenuInfo, setContextMenuInfo] = useState();
  const { handleShow } = useContext(popupcontext);
  const [startForm, setStartForm] = useState();
  const [endForm, setEndForm] = useState();
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  const [showMorePopupData, setShowMorePopupData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null); // New state for date
  const [isShowMorePopupVisible, setIsShowMorePopupVisible] = useState(false);

  const handleShowMore = (events, date) => {
    setShowMorePopupData(events); // Pass events to popup
    const dateString = dayjs(date).format("D MMM YYYY");
    setSelectedDate(dateString);
    setIsShowMorePopupVisible(true); // Show popup
  };

  const handleEventClick = (event, eventData) => {
    const rect = event.target.getBoundingClientRect();
    const x = rect.left + window.scrollX; // Calculate the X position
    const y = rect.top + window.scrollY - rect.height - 10; // Calculate the Y position above the component

    setPopupPosition({ x, y });
    setSelectedEvent(eventData);
    setIsPopupVisible(true);
  };

  const components = {
    event: ({ event }) => {
      const data = event?.data;
      if (data?.appointment) {
        return (
          <AppointmentEvent
            appointment={data.appointment}
            onClick={(e) => handleEventClick(e, event)}
          />
        );
      }
      if (data?.blockout) {
        return <BlockoutEvent blockout={data.blockout} />;
      }
      return null;
    },
    timeSlotWrapper: ({ children, value, resource }) => {
      return cloneElement(children, {
        onContextMenu: (e) => {
          e.preventDefault();
          setContextMenuInfo({
            xPosition: e.clientX,
            yPosition: e.clientY,
            selectedTime: value,
            resourceId: resource,
          });
        },
      });
    },
    dateCellWrapper: ({ value, children }) => <div>{children}</div>,
  };

  const onSelectTimeSlot = ({ start, end }) => {
    handleShow("addForm");
    setStartForm(start);
    setEndForm(end);
  };

  const today = new Date();
  const minTime = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
    9,
    0
  );
  const maxTime = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
    18,
    0
  );
  const [date, setDate] = useState(today);

  const onNextClick = useCallback(() => {
    let updatedDate;
    if (customView === Views.DAY || customView === Views.AGENDA) {
      updatedDate = dayjs(date).add(1, "day").toDate();
    } else if (customView === Views.WEEK) {
      updatedDate = dayjs(date).add(7, "day").toDate();
    } else if (customView === Views.MONTH) {
      updatedDate = dayjs(date).add(1, "month").toDate();
    }
    setDate(updatedDate);
  }, [date, customView]);

  const onPrevClick = useCallback(() => {
    let updatedDate;
    if (customView === Views.DAY || customView === Views.AGENDA) {
      updatedDate = dayjs(date).subtract(1, "day").toDate();
    } else if (customView === Views.WEEK) {
      updatedDate = dayjs(date).subtract(7, "day").toDate();
    } else if (customView === Views.MONTH) {
      updatedDate = dayjs(date).subtract(1, "month").toDate();
    }
    setDate(updatedDate);
  }, [date, customView]);

  const dateText = useMemo(() => {
    if (customView === Views.DAY || customView === Views.AGENDA)
      return dayjs(date).format("D MMM YYYY");
    if (customView === Views.WEEK) return dayjs(date).format("D MMM YYYY");
    if (customView === Views.MONTH) return dayjs(date).format("MMMM YYYY");
  }, [date, customView]);

  const HeadField = [
    "Code",
    "Requested By",
    "Vehicle",
    "Maintenance Type",
    "Description",
    "Actions",
  ];

  if (customView === "Upcoming") {
    return (
      <>
        <CalendarHeader
          customView={customView}
          setCustomView={setCustomView}
          onNextClick={onNextClick}
          onPrevClick={onPrevClick}
          dateText={dayjs(dateText)}
          setDate={setDate}
          today={today}
        />
        <Upcoming />
      </>
    );
  }
  if (customView === "Previous") {
    return (
      <>
        <CalendarHeader
          customView={customView}
          setCustomView={setCustomView}
          onNextClick={onNextClick}
          onPrevClick={onPrevClick}
          dateText={dayjs(dateText)}
          setDate={setDate}
          today={today}
        />
        <Upcoming />
      </>
    );
  }
  return (
    <>
      <div className="responsive-calendar-container">
        <CalendarHeader
          customView={customView}
          setCustomView={setCustomView}
          onNextClick={onNextClick}
          onPrevClick={onPrevClick}
          dateText={dayjs(dateText)}
          setDate={setDate}
          today={today}
        />
        <Calendar
          localizer={localizer}
          events={events}
          defaultView={Views.DAY}
          startAccessor="start"
          endAccessor="end"
          components={components}
          toolbar={false}
          view={customView}
          date={date}
          selectable
          onSelectSlot={({ start, end }) => {
            onSelectTimeSlot({ start, end });
          }}
          onShowMore={handleShowMore}
        />
      </div>
      <ScheduleForm start={startForm} end={endForm} />

      {isPopupVisible && (
        <EventPopup
          event={selectedEvent}
          position={popupPosition}
          onClose={() => setIsPopupVisible(false)}
        />
      )}
      {isShowMorePopupVisible && (
        <ViewMore
          events={showMorePopupData}
          onClose={() => setIsShowMorePopupVisible(false)}
          date={selectedDate}
        />
      )}
    </>
  );
};

export default Schedule;
